import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import LuSubscriptionPlanFeatureAppResource from './LuSubscriptionPlanFeatureAppResource';
import OrganizationAppResource from './OrganizationAppResource';
import OrganizationSubscriptionPlanAppResource from './OrganizationSubscriptionPlanAppResource';

export const STARTER_LIH = 'c4f988da-1805-4b3f-9209-2d02618178d4';
export const STANDARD = '9ed9c959-052a-459e-a11f-4712677381a8';
export const STARTER = 'db150d99-5ec3-4041-b423-66d4d179b6fd';
export const PROFESSIONAL = 'b564f2b1-6dec-4a88-b3c7-2dfaa5aacaac';
export const TEAM = '22c2cee0-fe2e-4dfc-b83c-b99899279ee8';
export const OHO_PROFESSIONAL = '41222653-2b53-427a-8ed8-4cb38838ad03';

export const LIVE_INHERE_TYPE = 'liveInHere';

class SubscriptionPlanAppResource extends AppResource {

  /**
   * @returns {string}
   */
  appResourceType() {
    return 'subscription-plan';
  }

  /**
   * @returns {string}
   */
  appResourceApiPrefix() {
    return 'subscriptions/plans';
  }

  /**
   * @returns {*[]}
   */
  hidden() {
    return super.hidden().concat([
      'uuid',
      'deleted_at',
    ]);
  }

  /**
   * @returns {*[]}
   */
  fillable() {
    return [
      'chargebeePlanMonthly',
      'chargebeePlanYearly',
      'title',
      'slug',
      'description',
      'order',
      'cta',
      'isSystem',
      'internalName',
      'stripeProductId',
      'stripePlanMonthly',
      'stripePlanYearly',
      'stripePlan3years',
    ];
  }

  /**
   * @returns {*[]}
   */
  relationMap() {
    return {
      subscriptionPlanFeatures: LuSubscriptionPlanFeatureAppResource,
      organizations: OrganizationAppResource,
      organizationSubscriptionPlans: OrganizationSubscriptionPlanAppResource,
    };
  }

  /**
   * @returns {*[]}
   */
  relationForeignKeys() {
    return [
    ];
  }

  /**
   * @returns {*}
   */
  validationRules() {
    return {
      chargebeePlanMonthly: {
        type: 'string',
        presence: true,
        length: {
          maximum: 255,
        },
      },
      chargebeePlanYearly: {
        type: 'string',
        presence: true,
        length: {
          maximum: 255,
        },
      },
      title: {
        type: 'string',
        presence: true,
        length: {
          maximum: 255,
        },
      },
      slug: {
        type: 'string',
        presence: true,
        length: {
          maximum: 255,
        },
      },
      description: {
        type: 'string',
        length: {
          maximum: 255,
        },
      },
      order: {
        type: 'integer',
        presence: true,
      },
      cta: {
        type: 'string',
        presence: true,
        length: {
          maximum: 255,
        },
      },
      isSystem: {
        type: 'boolean',
        presence: true,
      },
      internalName: {
        type: 'string',
        presence: true,
        length: {
          maximum: 255,
        },
      },
    };
  }
}

export default SubscriptionPlanAppResource;
